import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { orgIdParam } from './builderHelper';

export const documentationResources = {
  getDocumentation: createResourceBuilder('/docs/:organization_id', EResourceMethod.Get, orgIdParam()),
} as const;
